// FAZ-9 / MOD-18 — AD grup → CMS rolü eşlemesinde seçilebilecek roller.
//
// Değerler BE `RoleNames` (Domain/Identity/RoleNames.cs) ile BİREBİR eşleşmeli:
// JIT shadow-user her girişte rolünü `groupRoleMapJson`'dan senkronlar; eşleşmeyen
// bir rol adı sessizce düşer. Yönetsel/authoring rolleri (SuperAdmin/Admin/Editor/
// Author) — Viewer/Member AD grubundan eşlenmez.
export const LDAP_ASSIGNABLE_ROLES = ['SuperAdmin', 'Admin', 'Editor', 'Author'] as const;

export type LdapAssignableRole = (typeof LDAP_ASSIGNABLE_ROLES)[number];

/** LDAPS varsayılan portu (BIZ-LDAP-02). */
export const LDAP_DEFAULT_PORT = 636;

/** BE `LdapConfigFlow` `{0}` placeholder'ını zorunlu kılar (UserSearchFilter). */
export const LDAP_USER_FILTER_PLACEHOLDER = '{0}';
